import { Icon } from '@perch-labs/shrike';
import { Text } from '~/components/typography';

export const ContractErrorMessage = () => {
  return (
    <div style={{ display: 'flex' }}>
      <Icon icon="InfoCircleInverted" color="error" margin={{ top: '10px', right: '4px' }} />
      <Text textStyle="paragraph400" color="error" mt={2}>
        Something went wrong while loading your agreements. Please{' '}
        <a
          href=""
          onClick={e => {
            e.preventDefault();
            window.location.reload();
          }}
          style={{ textDecoration: 'underline', cursor: 'pointer', color: 'inherit' }}
        >
          refresh
        </a>{' '}
        the page to try again.
      </Text>
    </div>
  );
};
